import User from "@/shared/models/User";
import DocumentMetadata from "@/features/Documents/DocumentMetadata";

export enum CommentType {
    ScoreComment,
    IncidentComment,
}

export default class Comment {
    id: string | null = null;
    body: string = "";
    commentType: CommentType = null!;
    createdTimestampUTC: Date = new Date();
    createdBy: User = new User();
    createdByID: string = "";
    updatedTimestampUTC: Date = new Date();
    updatedBy: User = new User();
    updatedByID: string = "";
    documentMetadatas: DocumentMetadata[] = [];
    documentMetadataIDs: string[] = [];
}

export class ScoreComment extends Comment {
    scoreID: string = "";
}

export class IncidentComment extends Comment {
    incidentID: string = "";
}

export class CommentSummary {
    parentID: string = "";
    commentCount: number = 0;
    attachmentCount: number = 0;
}
